module.exports = __webpack_public_path__ + "img/cjc1_style_1_font_sprite.53a849de.webp";